jQuery(function($) {
	if (!$('.from_blog .slider').length)
		return;

	$('.from_blog .slider').on('init', function(event){
		$('.blog_and_buzz .slick-arrow').on('click', function() {
			setTimeout(function(){
				currentSlideEl = $('.from_blog .slider .slick-active');
				currentSlideEl.find('.slide_wrapper h3').focus();
			}, 300);
		});
	});

	initializeSlick('.from_blog .slider', {
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		nextArrow: '<button class="slider_arrow next_arrow">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow">Previous</button>',
	});
});